import { type AmountType } from '@alfa-bank/newclick-types';

import { MIN_TRANSFER_SUM, MIN_TRANSFER_VALUE } from '../constants';

import { getFormatedAmount } from './get-formated-amount';

export const validateTransferAmount = (
    amount: AmountType,
    limits: {
        maxSumPayment?: AmountType;
        goalAmountLimit?: AmountType;
    },
) => {
    let error = null;

    const { maxSumPayment, goalAmountLimit } = limits;

    if ((amount.value ?? 0) > (maxSumPayment?.value ?? 0) && goalAmountLimit) {
        const formatedLimit = getFormatedAmount(goalAmountLimit);

        error = `Проверьте сумму. Собрать можно только ${formatedLimit}`;
    }

    if ((amount.value ?? 0) < MIN_TRANSFER_VALUE) {
        error = `Проверьте сумму. Минимальная сумма ${MIN_TRANSFER_SUM}`;
    }

    return error;
};
